(() => {
  const pushEvent = (payload) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);
  };

  document.addEventListener('click', (event) => {
    const target = event.target instanceof Element ? event.target : event.target.parentElement;
    const link = target?.closest('a');
    if (!link) return;

    const href = link.getAttribute('href') || '';

    if (href.includes('wa.me/') || href.includes('api.whatsapp.com/')) {
      pushEvent({
        event: 'whatsapp_click',
        channel: 'whatsapp',
        item_name: link.dataset.gkWaItem || '',
        lead_reference: link.dataset.gkWaRef || '',
        rental_segment: link.dataset.gkWaSegment || '',
        vehicle_tier: link.dataset.gkWaTier || '',
        displayed_rate: link.dataset.gkWaRate || '',
        page_path: window.location.pathname,
      });
      return;
    }

    if (href.startsWith('tel:')) {
      pushEvent({
        event: 'phone_click',
        channel: 'phone',
        page_path: window.location.pathname,
      });
    }
  });
})();
